import Router from "vue-router"
import Login from "@/components/auth/Login"
import Courses from "@/components/course/Courses"

import Tree from "@/components/tree/newTree"

import ReadingList from "@/components/questions/ReadingList"
import Reading from "@/components/questions/Reading"
import ReadingEdit from "@/components/questions/ReadingEdit"

import InterviewQuestionList from "@/components/interviewQuestion/InterviewQuestionList"
import InterviewQuestion from "@/components/interviewQuestion/InterviewQuestion"
import InterviewQuestionEdit from "@/components/interviewQuestion/InterviewQuestionEdit"
import InterviewVideos from "@/components/interviewQuestion/InterviewVideos"

import MCQ from "@/components/questions/MCQ"

import VideoList from "@/components/video/VideoList"
import VideoEdit from "@/components/video/VideoEdit"

import FileUpload from "@/components/shared/FileUpload"

import LanguageList from "@/components/languages/LanguageList"
import LanguageAdd from "@/components/languages/LanguageAdd"
import LanguageEdit from "@/components/languages/LanguageEdit"

import InstitutionList from "@/components/institution/InstitutionList"
import InstitutionAdd from "@/components/institution/InstitutionAdd"
import InstitutionEdit from "@/components/institution/InstitutionEdit"

import EngineeringBranchesList from "@/components/engineeringBranches/EngineeringBranchesList"
import EngineeringBranchesEdit from "@/components/engineeringBranches/EngineeringBranchesEdit"
import EngineeringBranchesAdd from "@/components/engineeringBranches/EngineeringBranchesAdd"

import CouponList from "@/components/coupons/CouponList"
import CouponAdd from "@/components/coupons/CouponAdd"
import CouponEdit from "@/components/coupons/CouponEdit"

import CodingList from "@/components/coding/CodingList"

import CodingEditorContainer from "@/components/coding/CodingEditorContainer"

import HintList from "@/components/coding/HintList"
import CreateHint from "@/components/coding/CreateHint"
import HintEdit from "@/components/coding/HintEdit"

import EditorialList from "@/components/coding/EditorialList"
import CreateEditorial from "@/components/coding/CreateEditorial"
import EditorialEdit from "@/components/coding/EditorialEdit"

import PreassessmentsList from "@/components/preassessments/PreassessmentsList"
import PreassessmentsEdit from "@/components/preassessments/PreassessmentsEdit"
import PreassessmentsAdd from "@/components/preassessments/PreassessmentsAdd"

import CohortList from "@/components/cohort/CohortList"
import CohortEdit from "@/components/cohort/CohortEdit"

import QuestionBankCohortsList from "@/components/QuestionBankCohort/QuestionBankCohortsList"
import QuestionBankCohortForm from "@/components/QuestionBankCohort/QuestionBankCohortForm"

import MCQStitcher from "@/components/stitchedMCQs/MCQStitcher"
import StitchedMCQList from "@/components/stitchedMCQs/StitchedMCQList"
import StitchedMCQEvaluate from "@/components/stitchedMCQs/StitchedMCQEvaluate"
import StitchedMCQEdit from "@/components/stitchedMCQs/StitchedMCQEdit"

import TagList from "@/components/tags/TagList"
import TagEdit from "@/components/tags/TagEdit"
import TagAdd from "@/components/tags/TagAdd"

import MarkdownAttachment from "@/components/testComponents/MarkdownAttachment"

import AddUserToCohort from "@/components/addUserToCohort/AddUserToCohort"
import RemoveUserFromCohort from "@/components/removeUserFromCohort/RemoveUserFromCohort"

import GameList from "@/components/game/GameList"
import GameEdit from "@/components/game/GameEdit"
import GameAdd from "@/components/game/GameAdd"

import Reports from "@/components/reports/Reports"

import YouTubeReports from "@/components/reports/YouTubeReports"

import Assessment from "@/components/assignment/Assessment"
import AssessmentList from "@/components/assignment/AssessmentList"
import ReferralList from "@/components/externalReferral/ReferralList"
import UserMenu from "@/components/user/UserMenu"
import AssessmentVideos from "@/components/assessmentVideos/AssessmentVideos"
import YoutubeSessionUpdateAdminPage from "@/components/YoutubeLiveSessionsEditor/YoutubeSessionUpdateAdminPage"
import TestimonialCarouselAdminPage from "@/components/TestimonialCarouselAdminPage/TestimonialCarouselAdminPage"

import Ghost from "@/components/ghost/Ghost"
import AddWebQuestion from "@/components/Web/AddWebQuestion"
import EditWebQuestion from "@/components/Web/EditWebQuestion"
import WebQuestionList from "@/components/Web/WebQuestionList"
import Event from "@/components/Event/Event"
import EventList from "@/components/Event/EventList"

import JoinLinks from "@/components/JoinLinks/JoinLinks"
import JoinLink from "@/components/JoinLinks/JoinLink"

import JobListings from "@/components/JobListings/JobListings"
import JobForm from "@/components/JobListings/JobForm"

import DetailsFormPage from "@/components/userForms/DetailsFormPage"

import SurveyQuestionList from "@/components/surveyQuestion/SurveyQuestionList"
import EditSurveyQuestion from "@/components/surveyQuestion/EditSurveyQuestion"
import AddSurveyQuestion from "@/components/surveyQuestion/AddSurveyQuestion"
import CollegeCleanupAdminPage from "@/components/CollegeCleanup/CollegeCleanupAdminPage"
import ReportsDashboard from "@/components/ReportsDashboard/ReportsDashboard"
import CollegeAdminRoles from "@/components/CollegeAdminRoles/CollegeAdminRoles"
import ManageAdminRoles from "@/components/Roles/ManageAdminRoles"
import CertificateAdminPage from "@/components/certificate/CertificateAdminPage"
import CertificateList from "@/components/certificate/CertificateList"
import ProjectSubmissionList from "@/components/ProjectSubmission/ProjectSubmissionList"
import ProjectQuestionEditor from "@/components/ProjectQuestion/ProjectQuestionEditor"
import ProjectQuestionList from "@/components/ProjectQuestion/ProjectQuestionList"
import ReviewProjectSubmission from "@/components/ProjectSubmission/ReviewProjectSubmission"
import SprintEditor from "@/components/Sprint/SprintEditor"

import PlanForm from "@/components/subscription/PlanForm"
import PlanList from "@/components/subscription/PlanList"

import Notification from "@/components/Notification/Notification"
import SegmentBuilder from "@/components/Notification/SegmentBuilder"
import LiveClassBulkUploader from "@/components/Event/LiveClassBulkUploader"

import CompanyList from "@/components/company/CompanyList"
import CompanyForm from "@/components/company/CompanyForm"

import QuestionBankTagList from "@/components/questionBankTags/QuestionBankTagList"
import QuestionBankTagsForm from "@/components/questionBankTags/QuestionBankTagsForm"

import XPConditionsList from "@/components/XPConditions/XPConditionsList"
import XPConditionEditor from "@/components/XPConditions/XPConditionEditor"
import RewardsList from "@/components/Rewards/RewardsList"
import RewardEditor from "@/components/Rewards/RewardEditor"

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/subscription-plans",
      name: "PlanList",
      component: PlanList,
      meta: {
        roleRequired: ["admin"],
        title: "List Subscription Plans",
      },
    },
    {
      path: "/add-subscription-plan",
      name: "PlanForm",
      component: PlanForm,
      meta: {
        roleRequired: ["admin"],
        title: "Add Subscription Plan",
      },
    },
    {
      path: "/edit-subscription-plan/:id",
      name: "PlanForm",
      component: PlanForm,
      meta: {
        roleRequired: ["admin"],
        title: "Edit Subscription Plan",
      },
    },
    {
      path: "/calendar/:cohortId",
      name: "SprintAdd",
      component: SprintEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Add Sprints",
      },
    },
    {
      path: "/add-certificate",
      name: "CertificateAdd",
      component: CertificateAdminPage,
      meta: {
        roleRequired: ["admin"],
        title: "Add Certificate",
      },
    },
    {
      path: "/edit-certificate/:id",
      name: "CertificateEdit",
      component: CertificateAdminPage,
      meta: {
        roleRequired: ["admin"],
        title: "Edit Certificate",
      },
    },
    {
      path: "/certificates",
      name: "CertificateList",
      component: CertificateList,
      meta: {
        roleRequired: ["admin"],
        title: "Certificate",
      },
    },
    {
      path: "/assessment",
      name: "AssignmentNew",
      component: Assessment,
      meta: {
        roleRequired: ["admin"],
        title: "Add Assessment",
      },
    },
    {
      path: "/custom-forms",
      name: "Custom Forms",
      component: DetailsFormPage,
      meta: {
        roleRequired: ["admin"],
        title: "Add Custom Forms",
      },
    },
    {
      path: "/assessment/:assessment_id",
      name: "AssignmentEdit",
      component: Assessment,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/assessmentlist",
      name: "AssessmentList",
      component: AssessmentList,
      meta: {
        roleRequired: ["admin"],
        title: "Assessments",
      },
    },
    {
      path: "/reports",
      name: "Reports",
      component: Reports,
      meta: {
        roleRequired: ["admin"],
        title: "Reports",
      },
    },
    {
      path: "/youtube-reports",
      name: "YouTubeReports",
      component: YouTubeReports,
      meta: {
        roleRequired: ["admin"],
        title: "YouTube Reports",
      },
    },
    {
      path: "/markdown",
      name: "MarkdownAttachment",
      component: MarkdownAttachment,
      meta: {
        roleRequired: ["admin"],
        title: "Markdown Attachment Editor",
      },
    },
    {
      path: "/add-user-to-cohort",
      name: "AddUserToCohort",
      component: AddUserToCohort,
      meta: {
        roleRequired: ["admin"],
        title: "Add User to Cohort",
      },
    },
    {
      path: "/reset-user",
      name: "RemoveUserFromCohort",
      component: RemoveUserFromCohort,
      meta: {
        roleRequired: ["admin"],
        title: "Reset User",
      },
    },
    {
      path: "/",
      name: "Login",
      component: Login,
      meta: {
        title: "Login Page",
      },
    },
    {
      path: "/courses",
      name: "Courses",
      component: Courses,
      meta: {
        roleRequired: ["admin"],
        title: "Courses",
      },
    },
    {
      path: "/course/:id",
      name: "Tree",
      component: Tree,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/reading",
      name: "ReadingList",
      component: ReadingList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Readings",
      },
    },
    {
      path: "/reading-new",
      name: "Reading",
      component: Reading,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Reading",
      },
    },
    {
      path: "/reading-edit/:id",
      name: "ReadingEdit",
      component: ReadingEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/game",
      name: "GameList",
      component: GameList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Games",
      },
    },
    {
      path: "/game-add",
      name: "GameAdd",
      component: GameAdd,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Game",
      },
    },
    {
      path: "/game-edit/:id",
      name: "GameEdit",
      component: GameEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/video",
      name: "video",
      component: VideoList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Videos",
      },
    },
    {
      path: "/video-new",
      name: "videonew",
      component: VideoEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Video",
      },
    },
    {
      path: "/video-edit/:id",
      name: "videonedit",
      component: VideoEdit,
      props: {
        editMode: true,
      },
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/mcq",
      name: "MCQ",
      component: MCQ,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "MCQ Questions",
      },
    },
    {
      path: "/mcq-stitcher-add",
      name: "MCQStitcherAdd",
      component: MCQStitcher,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add MCQ Question",
      },
    },
    {
      path: "/mcq-stitcher-edit/:id",
      name: "MCQStitcherEdit",
      component: MCQStitcher,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },

    {
      path: "/mcq-stitched",
      name: "StitchedMCQList",
      component: StitchedMCQList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Stitched MCQ Questions",
      },
    },
    // mcq-stitched-edit
    {
      path: "/mcq-stitched-evaluate/:id",
      name: "StitchedMCQEvaluate",
      component: StitchedMCQEvaluate,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Evaluate Stitched MCQ",
      },
    },
    {
      path: "/mcq-stitched-edit/:id",
      name: "StitchedMCQEdit",
      component: StitchedMCQEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "", // route not found
      },
    },
    {
      path: "/interview",
      name: "InterviewQuestionList",
      component: InterviewQuestionList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Interview Questions",
      },
    },
    {
      path: "/interview-question-new",
      name: "InterviewQuestionNew",
      component: InterviewQuestion,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Interview Question",
      },
    },
    {
      path: "/interview-question-edit/:id",
      name: "InterviewQuestionEdit",
      component: InterviewQuestionEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/interview-videos/:id?",
      name: "InterviewVideos",
      component: InterviewVideos,
      meta: {
        roleRequired: ["admin"],
        title: "Interview Videos",
      },
    },
    {
      path: "/file",
      name: "FileUpload",
      component: FileUpload,
      meta: {
        roleRequired: ["admin"],
        title: "Upload File",
      },
    },
    // /
    {
      path: "/language",
      name: "LanguageList",
      component: LanguageList,
      meta: {
        roleRequired: ["admin"],
        title: "Languages",
      },
    },
    {
      path: "/language-add",
      name: "LanguageAdd",
      component: LanguageAdd,
      meta: {
        roleRequired: ["admin"],
        title: "Add Language",
      },
    },
    {
      path: "/language-edit/:id",
      name: "LanguageEdit",
      component: LanguageEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    // /
    {
      path: "/institution",
      name: "InstitutionList",
      component: InstitutionList,
      meta: {
        roleRequired: ["admin"],
        title: "Institutions",
      },
    },
    {
      path: "/institution-add",
      name: "InstitutionAdd",
      component: InstitutionAdd,
      meta: {
        roleRequired: ["admin"],
        title: "Add Institution",
      },
    },
    {
      path: "/institution-edit/:id",
      name: "InstitutionEdit",
      component: InstitutionEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    // /engineering-branches
    {
      path: "/engineering-branches",
      name: "EngineeringBranchesList",
      component: EngineeringBranchesList,
      meta: {
        roleRequired: ["admin"],
        title: "Engineering Branches",
      },
    },
    // /tags
    {
      path: "/tags",
      name: "TagList",
      component: TagList,
      meta: {
        roleRequired: ["admin"],
        title: "Tags",
      },
    },
    {
      path: "/tag-add",
      name: "TagAdd",
      component: TagAdd,
      meta: {
        roleRequired: ["admin"],
        title: "Add Tag",
      },
    },
    {
      path: "/tag-edit/:id",
      name: "TagEdit",
      component: TagEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/engineering-branches-add",
      name: "EngineeringBranchesAdd",
      component: EngineeringBranchesAdd,
      meta: {
        roleRequired: ["admin"],
        title: "Add Engineering Branch",
      },
    },
    {
      path: "/engineering-branches-edit/:id",
      name: "EngineeringBranchesEdit",
      component: EngineeringBranchesEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    // ///
    {
      path: "/coupons",
      name: "CouponList",
      component: CouponList,
      meta: {
        roleRequired: ["admin"],
        title: "Coupons",
      },
    },
    {
      path: "/coupons-add",
      name: "CouponAdd",
      component: CouponAdd,
      meta: {
        roleRequired: ["admin"],
        title: "Add Coupon",
      },
    },
    {
      path: "/coupons-edit/:coupon_id",
      name: "CouponEdit",
      component: CouponEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },

    // ///
    {
      path: "/coding",
      name: "CodingList",
      component: CodingList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Coding Questions",
      },
    },

    // ///
    {
      path: "/hint",
      name: "HintList",
      component: HintList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Hints",
      },
    },

    // ////
    {
      path: "/hint-add",
      name: "CreateHint",
      component: CreateHint,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Hint",
      },
    },

    // ///
    {
      path: "/hint/:id",
      name: "HintEdit",
      component: HintEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },

    // ///
    {
      path: "/editorial",
      name: "EditorialList",
      component: EditorialList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Editorials",
      },
    },
    // ///

    {
      path: "/editorial-add",
      name: "CreateEditorial",
      component: CreateEditorial,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Editorial",
      },
    },

    // ///
    {
      path: "/editorial/:id",
      name: "EditorialEdit",
      component: EditorialEdit,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },

    // ///
    {
      path: "/blockly",
      name: "BlocklyList",
      component: CodingList,
      props: { is_blockly: true },
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Blockly Questions",
      },
    },
    // CodeAddEdit
    {
      path: "/code/:id",
      name: "EditCoding",
      component: CodingEditorContainer,
      props: { editMode: true },
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/web-questions",
      name: "WebQuestionList",
      component: WebQuestionList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Web Questions",
      },
    },
    {
      path: "/web-question-edit/:id",
      name: "EditWebQuestion",
      component: EditWebQuestion,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/web-question-add",
      name: "AddWebQuestion",
      component: AddWebQuestion,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Web Questions",
      },
    },
    {
      path: "/project-submissions",
      name: "ProjectSubmissionList",
      query: {
        sort_by: "-updated_on",
        cohort_id: "",
        author: "",
        reviewer: "",
        review_state: "pending",
      },
      component: ProjectSubmissionList,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Project Submissions",
      },
    },
    {
      path: "/review-submissions/:submissionId",
      name: "ReviewProjectSubmission",
      component: ReviewProjectSubmission,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Review Submission",
      },
    },
    {
      path: "/add-project-question",
      name: "AddProjectQuestion",
      component: ProjectQuestionEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Add Project Question",
      },
    },
    {
      path: "/edit-project-question/:id",
      name: "EditProjectQuestion",
      props: {
        editMode: true,
      },
      component: ProjectQuestionEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Edit Project Question",
      },
    },
    {
      path: "/project-questions",
      name: "ProjectQuestionList",
      component: ProjectQuestionList,
      meta: {
        roleRequired: ["admin"],
        title: "Project Questions",
      },
    },
    {
      path: "/add-xp-condition",
      name: "AddXPCondition",
      component: XPConditionEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Create XP Condition",
      },
    },
    {
      path: "/edit-xp-condition/:id",
      name: "EditXPCondition",
      props: {
        editMode: true,
      },
      component: XPConditionEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Edit XP Condition",
      },
    },
    {
      path: "/xp-conditions",
      name: "XPConditionList",
      component: XPConditionsList,
      meta: {
        roleRequired: ["admin"],
        title: "XP Conditions",
      },
    },
    {
      path: "/create-reward",
      name: "AddReward",
      component: RewardEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Create Reward",
      },
    },
    {
      path: "/edit-reward/:id",
      name: "EditReward",
      props: {
        editMode: true,
      },
      component: RewardEditor,
      meta: {
        roleRequired: ["admin"],
        title: "Edit Reward",
      },
    },
    {
      path: "/rewards",
      name: "RewardsList",
      component: RewardsList,
      meta: {
        roleRequired: ["admin"],
        title: "Rewards",
      },
    },
    {
      path: "/coding-add",
      name: "AddCoding",
      component: CodingEditorContainer,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Coding Question",
      },
    },

    // BlocklyAddEdit
    {
      path: "/blockly/:id",
      name: "EditCoding",
      component: CodingEditorContainer,
      props: { is_blockly: true, editMode: true },
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "dynamic",
      },
    },
    {
      path: "/blockly-add",
      name: "AddCoding",
      component: CodingEditorContainer,
      props: { is_blockly: true },
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Add Blockly Question",
      },
    },

    // /
    // ///
    {
      path: "/preassessments",
      name: "PreassessmentsList",
      component: PreassessmentsList,
      meta: {
        roleRequired: ["admin"],
        title: "Preassessments List",
      },
    },
    {
      path: "/preassessments-add",
      name: "PreassessmentsAdd",
      component: PreassessmentsAdd,
      meta: {
        roleRequired: ["admin"],
        title: "Add Preassessment",
      },
    },
    {
      path: "/preassessments-edit/:id",
      name: "PreassessmentsEdit",
      component: PreassessmentsEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    // /// survey questions
    {
      path: "/survey_questions",
      name: "SurveyQuestionList",
      component: SurveyQuestionList,
      meta: {
        roleRequired: ["admin"],
        title: "Survey Questions",
      },
    },
    // ///
    {
      path: "/survey_questions/add",
      name: "AddSurveyQuestion",
      component: AddSurveyQuestion,
      meta: {
        roleRequired: ["admin"],
        title: "Add Survey Question",
      },
    },
    // ///
    {
      path: "/survey_questions/:id",
      name: "EditSurveyQuestion",
      component: EditSurveyQuestion,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    // ///
    // ///
    {
      path: "/cohort",
      name: "CohortList",
      component: CohortList,
      meta: {
        roleRequired: ["admin"],
        title: "Cohorts",
      },
    },
    {
      path: "/cohort-add",
      name: "CohortAdd",
      component: CohortEdit,
      meta: {
        roleRequired: ["admin"],
        title: "Add Cohort",
      },
    },
    {
      path: "/cohort-edit/:id",
      name: "CohortEdit",
      props: {
        editMode: true,
      },
      component: CohortEdit,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/question-bank/cohort",
      name: "QuestionBankCohortsList",
      component: QuestionBankCohortsList,
      meta: {
        roleRequired: ["admin"],
        title: "QuestionBankCohorts",
      },
    },
    {
      path: "/question_bank/cohorts/:id",
      name: "QuestionBankCohortForm",
      props: {
        editMode: true,
      },
      component: QuestionBankCohortForm,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/question_bank/create-cohort",
      name: "QuestionBankCohortForm",
      component: QuestionBankCohortForm,
      meta: {
        roleRequired: ["admin"],
        title: "Add Question Bank Cohort",
      },
    },
    {
      path: "/referrals",
      name: "Referrals",
      component: ReferralList,
      meta: {
        roleRequired: ["admin"],
        title: "Referrals",
      },
    },
    {
      path: "/user",
      name: "User",
      component: UserMenu,
      meta: {
        roleRequired: ["admin"],
        title: "User Menu",
      },
    },
    {
      path: "/manage-reports-dashboards",
      name: "ReportsDashboard",
      component: ReportsDashboard,
      meta: {
        roleRequired: ["admin"],
        title: "Reports Dashboard",
      },
    },
    {
      path: "/manage-admin-roles",
      name: "CollegeAdminRoles",
      component: CollegeAdminRoles,
      meta: {
        roleRequired: ["admin", "communityManager"],
        title: "College Admin Roles Menu",
      },
    },
    {
      path: "/manage-roles",
      name: "ManageRoles",
      component: ManageAdminRoles,
      meta: {
        roleRequired: ["admin"],
        title: "Manage Admin Roles",
      },
    },
    {
      path: "/manage-students",
      name: "CommunityManagerAdminPage",
      component: UserMenu,
      meta: {
        roleRequired: ["communityManager"],
        title: "Community Manager Admin",
      },
    },
    {
      path: "/college-cleanup",
      name: "CollegeCleanupAdminPage",
      component: CollegeCleanupAdminPage,
      query: {
        sort_by: "created_on",
        page: 1,
        per_page: 20,
        search: "",
      },
      meta: {
        roleRequired: ["admin", "communityManager"],
        title: "College Cleanup Admin",
      },
    },
    {
      path: "/assessments",
      name: "Assessments",
      component: AssessmentVideos,
      meta: {
        roleRequired: ["admin"],
        title: "Assessment Videos",
      },
    },
    {
      path: "/update-youtube-session",
      name: "YoutubeSessionUpdateAdminPage",
      component: YoutubeSessionUpdateAdminPage,
      meta: {
        roleRequired: ["admin", "marketing"],
        title: "Manage Landing Page Webinar",
      },
    },
    {
      path: "/update-testimonial-carousel",
      name: "TestimonialCarouselAdminPage",
      component: TestimonialCarouselAdminPage,
      meta: {
        roleRequired: ["admin", "marketing"],
        title: "Manage Testimonial Carousels",
      },
    },
    {
      path: "/ghostcms",
      name: "GhostCMS",
      component: Ghost,
      meta: {
        roleRequired: ["admin", "questionadmin"],
        title: "Ghost CMS",
      },
    },
    {
      path: "/events/bulk-upload",
      name: "EventsBulkUploader",
      component: LiveClassBulkUploader,
      meta: {
        roleRequired: ["admin"],
        title: "Bulk Create Zoom Classes",
      },
    },
    {
      path: "/events/:eventType",
      name: "Events",
      component: Event,
      meta: {
        roleRequired: ["admin"],
        title: "Add Event",
      },
    },

    {
      path: "/events/contest/:slug",
      name: "Events",
      component: Event,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/events/liveclass/:slug",
      name: "Events",
      component: Event,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/notification",
      name: "EdystNotification",
      component: Notification,
      meta: {
        roleRequired: ["admin", "marketing"],
        title: "Edyst Campaigns & Notification",
      },
    },
    {
      path: "/edit-segment/:segment_id",
      name: "EditSegment",
      component: SegmentBuilder,
      meta: {
        roleRequired: ["admin"],
        title: "dynamic",
      },
    },
    {
      path: "/event-list/liveclass",
      name: "LiveClassList",
      component: EventList,
      meta: {
        roleRequired: ["admin"],
        title: "Live Classes",
      },
    },
    {
      path: "/event-list/contest",
      name: "ContestList",
      component: EventList,
      meta: {
        roleRequired: ["admin"],
        title: "Contests",
      },
    },
    {
      path: "/join-link/:linkId?",
      name: "JoinLink",
      component: JoinLink,
      meta: {
        roleRequired: ["admin", "communityManager"],
        title: "Add Join Link",
      },
    },
    {
      path: "/join-links-list",
      name: "JoinLinks",
      component: JoinLinks,
      meta: {
        roleRequired: ["admin", "communityManager"],
        title: "Join Links",
      },
    },
    {
      path: "/job-listing/:slug?",
      name: "JobListing",
      component: JobForm,
      meta: {
        roleRequired: ["admin", "communityManager", "marketing"],
        title: "Add Job",
      },
    },
    {
      path: "/job-listing-list",
      name: "JobListings",
      component: JobListings,
      meta: {
        roleRequired: ["admin", "communityManager", "marketing"],
        title: "Job Listings",
      },
    },
    {
      path: "/company",
      name: "CompanyList",
      component: CompanyList,
      meta: {
        roleRequired: ["admin"],
        title: "Company List",
      },
    },
    {
      path: "/company-listing/:id",
      name: "CompanyForm",
      component: CompanyForm,
      meta: {
        roleRequired: ["admin"],
        title: "Company",
      },
    },
    {
      path: "/create-company",
      name: "CompanyForm",
      component: CompanyForm,
      meta: {
        roleRequired: ["admin"],
        title: "Add Company",
      },
    },
    {
      path: "/questionbank-tags",
      name: "QuestionBankTagList",
      component: QuestionBankTagList,
      meta: {
        roleRequired: ["admin"],
      },
    },
    {
      path: "/questionbank-tag/:id",
      name: "QuestionBankTagsForm",
      component: QuestionBankTagsForm,
      meta: {
        roleRequired: ["admin"],
      },
    },
    {
      path: "/create-tag",
      name: "QuestionBankTagsForm",
      component: QuestionBankTagsForm,
      meta: {
        roleRequired: ["admin"],
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title && to.meta.title !== "dynamic") {
    window.pageTitle = to.meta.title
  }
  if (to.matched.some(record => record.meta.roleRequired)) {
    if (to.meta.roleRequired.includes(localStorage.role)) {
      next()
      return
    }
    next("/")
  } else {
    next()
  }
})

export default router
